import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

export function flxValues() {
    const valuesBlock = document.querySelector('.flx-values');

    if (!valuesBlock) {
        return;
    }

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: valuesBlock,
            start: 'top 75%',
            end: 'top bottom',
            toggleActions: 'play none none reset'
        }
    });

    tl.from('#values-line-mask', {
        drawSVG: '0% 0%',
        duration: 2
    });
    tl.to(
        '.flx-values__card .card-image',
        {
            opacity: 1,
            scale: 1,
            //y: 0,
            ease: 'elastic.out(0.25,0.25)',
            stagger: 0.2,
            duration: 1
        },
        '<'
    );
    /*     tl.to('.flx-values__card path', {
        fill: '#1d1d1b'
    }); */
    /* tl.to(
        '.flx-values__card h3',
        {
            color: '#fff'
        },
        '<'
    ); */
}
